import { useEffect, useRef, useState } from 'react';
import Script from 'next/script';

import { Field, Text } from '@sitecore-jss/sitecore-jss-nextjs';

import { ComponentProps } from 'src/lib/ComponentProps';

import IsSitecoreEditing from 'src/utils/isSitecoreEditing';

import styles from './Advert.module.css';

type AdvertProps = ComponentProps & {
	fields: {
		Title: Field<string>;
		NarrowId: Field<string>;
		WideId: Field<string>;
	};
	asListingCard?: boolean;
};

export default function Advert(props: AdvertProps): JSX.Element {
	const adRef = useRef<HTMLModElement>(null);
	const isEditing = IsSitecoreEditing();
	const [showAdvert, setShowAdvert] = useState(false);

	useEffect(() => {
		const adId =
			props.asListingCard || window.innerWidth < 600
				? props.fields.NarrowId
					? props.fields.NarrowId?.value
					: ''
				: props.fields.WideId
				? props.fields.WideId?.value
				: '';

		if (adRef.current) {
			adRef.current.dataset.reviveZoneid = adId;
		}
	}, []);

	useEffect(() => {
		if (!showAdvert) {
			const interval = setInterval(() => {
				if (document.getElementsByClassName('advertContent')[0]?.innerHTML.length > 0) {
					setShowAdvert(true);
				}
			}, 60000);

			return () => clearInterval(interval);
		}
		return;
	}, [showAdvert]);

	return (
		<section className={`cen Advert maxWidth ${!props.asListingCard ? 'padX padYS' : styles.listingCard} ${!showAdvert && styles.hidden}`}>
			<Text tag="p" field={props.fields.Title} />
			<div className={`${!props.asListingCard && styles.container}`}>
				{isEditing ? (
					<p>Advert will appear here</p>
				) : (
					<ins ref={adRef} className="advertContent" data-revive-id="fc111e649af709d884cd5b826f9a6d70" />
				)}
			</div>
			{!isEditing && <Script src="/BannerAds.js" />}
		</section>
	);
}
